actionHandler = {
    clampedRows: '140px',
    openedName: 'READ MORE',
    closedName: 'CLOSE',
    
    $triggerReadMore: $('.trigger-read-more'),
    $triggerRecommendation: $('.trigger-back-to-most'),
    $triggerRecommendationItem: $('.trigger-back-to-most-item'),
    $descClampContainer: $('.desc-clamp-container'),

    breadcrumbAnimTL: null,

    init = function(){ 
        var self = this;

        if ($('body.single-actions').length == 0) return;

        mostHandler.clickableActionBox();

        // this.$descClampContainer.children().each(function() {
        //     $clamp(this, {clamp: self.clampedRows});
        // });

        // breadcrumb recommendation animation on hover
        if (Foundation.MediaQuery.atLeast('medium') && $('html').hasClass('no-touchevents')) {
            this.breadcrumbAnimTL = new TimelineMax({ paused: true });
            this.breadcrumbAnimTL.to('.breadcrumb-recommendation-label', 0.25, {
                width: "auto"
            });
    
            $('.panel-breadcrumbs')
                .on("mouseenter", function() {
                    self.breadcrumbAnimTL.play();
                })
                .on("mouseleave", function() {
                    self.breadcrumbAnimTL.reverse();
                })
            ;    
        } else {
            $('.breadcrumb-recommendation-label').css('width', 'auto');
        }

        this.$triggerRecommendation.on("click", function() {
            document.location = '/recommendation';
        });

        this.$triggerRecommendationItem.on("click", function() {
            var mostItem = $(this).data('item');
            document.location = '/recommendation/#'+mostItem;
        });

        this.$triggerReadMore.on('click', function(e) {
            e.preventDefault();
            var id = $(this).data('id');
            var $descClampContainer = $('.desc-clamp-container[data-id='+id+']') ;
            var isClamp = $descClampContainer.data('clamp-stat');

            if (isClamp == 1) {
                $descClampContainer.toggleClass('unclamp');
    
                if ($(this).hasClass('opened')) {
                    $(this).text(self.openedName);
                } else {
                    $(this).text(self.closedName);
                }
                $(this).toggleClass('opened');
            }
        });
    }
}